import { ReactNode } from 'react';
import { Text } from '@belong/ui';
import { Footer } from 'src/components/footer/footer';
import { Header } from 'src/components/header/header';
import type { NeighborhoodLandingPageProps } from 'src/features/homeowners-neighborhood/components/landing-page/landing-page';
import { ReferralBanner } from 'src/features/homeowners/components/referral-banner/referral-banner';

export const getNeighborhoodLandingPageLayout = (
  page: ReactNode,
  props: NeighborhoodLandingPageProps,
): ReactNode => {
  const {
    cityData: { stateId },
    neighborhoodData: { neighborhood },
  } = props;

  return (
    <div className="relative flex min-h-full flex-col">
      <ReferralBanner />
      <Header variant="secondary" theme="dark" />
      <div className="h-xs container relative flex justify-end">
        <Text
          as="h1"
          variant="p2"
          className="bottom-xs text-dark-gray absolute"
        >
          {neighborhood}, {stateId} Property Management
        </Text>
      </div>
      <main className="flex-1">{page}</main>
      <Footer />
    </div>
  );
};
